import script from "./Slider.vue?vue&type=script&setup=true&lang=js"
export * from "./Slider.vue?vue&type=script&setup=true&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=28ea8d00&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ea8d00"]])

export default __exports__